import type {
  VoiceEvent,
  VoiceEventRequest,
  VoiceEventResponse,
  VoiceScreen,
  VoiceSessionState,
} from "@ghalishor/voice-core";

export type VoiceEventTransport = (
  input: VoiceEventRequest,
  authenticated: boolean,
) => Promise<VoiceEventResponse>;

export class CustomerVoiceExpertV3Client {
  private state: VoiceSessionState | null = null;
  private sequence = 0;
  private queue: Promise<void> = Promise.resolve();

  constructor(private readonly transport: VoiceEventTransport) {}

  enter(screen: VoiceScreen, authenticated: boolean): Promise<VoiceEventResponse> {
    return this.send({ id: this.eventId("enter"), type: "screen_entered", screen }, authenticated);
  }

  replay(authenticated: boolean): Promise<VoiceEventResponse> {
    return this.send({ id: this.eventId("replay"), type: "replay_requested" }, authenticated);
  }

  answer(transcript: string): Promise<VoiceEventResponse> {
    return this.send(
      { id: this.eventId("answer"), type: "order_answer", transcript: transcript.trim() },
      true,
    );
  }

  snapshot(): VoiceSessionState | null {
    return this.state;
  }

  reset(): void {
    this.state = null;
  }

  private send(event: VoiceEvent, authenticated: boolean): Promise<VoiceEventResponse> {
    const operation = this.queue.then(async () => {
      const response = await this.transport(
        { state: this.state ?? undefined, event },
        authenticated,
      );
      this.state = response.state;
      return response;
    });
    this.queue = operation.then(() => undefined, () => undefined);
    return operation;
  }

  private eventId(kind: string): string {
    this.sequence += 1;
    return `web.${kind}.${Date.now().toString(36)}.${this.sequence.toString(36)}`;
  }
}
